import { useLanguage } from '../contexts/LanguageContext';

type Props = {
    open: boolean;
    onClose: () => void;
};
type Lang = "english" | "hindi" | "marathi";

const messages: Record<Lang, string> = {
    english: "There is already an application with the same Mouja, Khasara Number & Plot Number in process. So your current application cannot be saved.",
    marathi: "सिस्टममध्ये समान मौजा, खसरा क्रमांक व प्लॉट क्रमांकाचा अर्ज आधीच नोंदणीकृत आहे. त्यामुळे सदर अर्ज जतन करता येणार नाही.",
    hindi: "इस मौजा, खसरा नंबर और प्लॉट नंबर का आवेदन सिस्टम में पहले से मौजूद है, इसलिए यह नया आवेदन सेव नहीं हो सकता।"
};

const titleText: Record<Lang, string> = {
    english: "Duplicate Application",
    marathi: "दुप्पट अर्ज (Duplicate Application)",
    hindi: "Duplicate Application"
};

export function DuplicateApplicationPopup({ open, onClose }: Props) {
    const lang = useLanguage();

    const currentLang: Lang =
        lang === "hindi" || lang === "marathi" ? lang : "english";

    if (!open) return null;

    const handleClose = () => {
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-[440px] text-left shadow-lg">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold text-gray-800">{titleText[currentLang]}</h2>
                    <button
                        onClick={handleClose}
                        className="px-2 py-1 rounded-md opacity-100 p-[7px] gap-2.5 bg-primary text-white"
                        title="Close"
                        type="button"
                    >
                        ✕
                    </button>
                </div>
                <p className="text-base text-gray-700">{messages[currentLang]}</p>
            </div>
        </div>
    );
}
